import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetEnrollmentGoalsArgs } from "../schemas";

const getEnrollmentGoalsQueryKey = (args: GetEnrollmentGoalsArgs) =>
  ["getEnrollmentGoals", args.health_care_organization_id] as const;

export const useGetEnrollmentGoals = (args: GetEnrollmentGoalsArgs) => {
  const client = useApiClient();

  return useQuery({ queryKey: getEnrollmentGoalsQueryKey(args), queryFn: () => client.getEnrollmentGoals(args) });
};
